var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4, _rect5, _circle2, _circle3, _path5, _path6, _path7, _rect6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 150,
    viewBox: "0 0 590 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 70,
    stroke: "black",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 95H115V105H95V95Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 77H370V87H350V77Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 70,
    width: 20,
    height: 10,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 52,
    width: 20,
    height: 10,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 45H45V105H35V45Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 27H210V87H200V27Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 45,
    width: 10,
    height: 60,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 27,
    width: 10,
    height: 60,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 27,
    width: 10,
    height: 60,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 57,
    r: 25,
    stroke: "black",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 57,
    r: 25,
    stroke: "black",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M503 57C503 62.7839 500.995 68.3888 497.325 72.8598C493.656 77.3308 488.55 80.3913 482.877 81.5196C477.205 82.648 471.316 81.7745 466.215 79.048C461.114 76.3215 457.116 71.9107 454.903 66.5671C452.69 61.2235 452.398 55.2777 454.076 49.7429C455.755 44.2081 459.302 39.4266 464.111 36.2133C468.92 32.9999 474.694 31.5535 480.45 32.1204C486.206 32.6873 491.588 35.2325 495.678 39.3223",
    stroke: "black",
    strokeWidth: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M585.678 74.6777C582.181 78.174 577.727 80.555 572.877 81.5196C568.028 82.4843 563.001 81.9892 558.433 80.097C553.865 78.2048 549.96 75.0005 547.213 70.8893C544.466 66.778 543 61.9445 543 57C543 52.0555 544.466 47.222 547.213 43.1108C549.96 38.9995 553.865 35.7952 558.433 33.903C563.001 32.0108 568.028 31.5157 572.877 32.4804C577.727 33.445 582.181 35.826 585.678 39.3223",
    stroke: "black",
    strokeWidth: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M478 52H508V57L501 62H478V52Z",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 27,
    width: 10,
    height: 60,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200 107.405H201.621V114.164H209.815V107.405H211.436V123.518H209.815V115.741H201.621V123.518H200V107.405Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.467 107C235.906 107 237.947 107.814 239.59 109.443C241.234 111.071 242.055 113.076 242.055 115.456C242.055 117.815 241.234 119.816 239.59 121.459C237.955 123.102 235.957 123.924 233.599 123.924C231.211 123.924 229.195 123.106 227.552 121.47C225.909 119.834 225.088 117.855 225.088 115.533C225.088 113.985 225.46 112.55 226.205 111.228C226.957 109.906 227.979 108.873 229.272 108.128C230.565 107.376 231.963 107 233.467 107ZM233.544 108.577C232.354 108.577 231.225 108.888 230.159 109.508C229.093 110.129 228.261 110.965 227.662 112.017C227.063 113.068 226.764 114.24 226.764 115.533C226.764 117.446 227.424 119.064 228.746 120.386C230.075 121.7 231.675 122.357 233.544 122.357C234.793 122.357 235.947 122.054 237.005 121.448C238.072 120.842 238.9 120.013 239.492 118.962C240.091 117.91 240.39 116.742 240.39 115.456C240.39 114.178 240.091 113.025 239.492 111.995C238.9 110.958 238.064 110.129 236.983 109.508C235.903 108.888 234.756 108.577 233.544 108.577Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M253.121 108.972V107.405H263.956V108.972H259.366V123.518H257.722V108.972H253.121Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M275.712 107.405H284.946V108.994H277.322V114.032H284.88V115.61H277.322V121.93H284.88V123.518H275.712V107.405Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M298.16 107.405H299.781V121.963H305.97V123.518H298.16V107.405Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.873 123.518L337.162 107.405H337.425L343.976 120.627L350.46 107.405H350.723L353.034 123.518H351.446L349.869 111.995L344.173 123.518H343.767L337.995 111.907L336.428 123.518H334.873Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M373.237 107.405L380.751 123.518H379.02L376.49 118.217H369.545L367.026 123.518H365.229L372.842 107.405H373.237ZM373.039 110.823L370.268 116.661H375.778L373.039 110.823Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393.702 123.518V107.405H394.052L404.765 119.739V107.405H406.353V123.518H405.992L395.367 111.338V123.518H393.702Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.312 107.405L434.826 123.518H433.095L430.565 118.217H423.62L421.101 123.518H419.304L426.917 107.405H427.312ZM427.114 110.823L424.343 116.661H429.853L427.114 110.823Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M463.309 110.111L462.06 111.294C461.162 110.41 460.176 109.742 459.103 109.289C458.037 108.829 456.996 108.599 455.981 108.599C454.718 108.599 453.513 108.91 452.366 109.53C451.227 110.151 450.344 110.994 449.715 112.061C449.087 113.12 448.773 114.24 448.773 115.423C448.773 116.636 449.098 117.789 449.748 118.885C450.398 119.973 451.296 120.831 452.443 121.459C453.589 122.08 454.845 122.39 456.211 122.39C457.869 122.39 459.271 121.923 460.417 120.988C461.564 120.053 462.243 118.841 462.455 117.351H457.317V115.796H464.262C464.247 118.286 463.506 120.265 462.039 121.733C460.578 123.193 458.621 123.924 456.167 123.924C453.188 123.924 450.829 122.909 449.091 120.878C447.755 119.316 447.087 117.508 447.087 115.456C447.087 113.93 447.47 112.51 448.237 111.195C449.004 109.881 450.055 108.855 451.391 108.117C452.728 107.372 454.239 107 455.926 107C457.292 107 458.577 107.248 459.782 107.745C460.987 108.234 462.163 109.023 463.309 110.111Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M477.772 107.405H487.006V108.994H479.382V114.032H486.94V115.61H479.382V121.93H486.94V123.518H477.772V107.405Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M499.486 123.518L501.775 107.405H502.038L508.588 120.627L515.073 107.405H515.336L517.647 123.518H516.059L514.481 111.995L508.785 123.518H508.38L502.607 111.907L501.041 123.518H499.486Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M531.277 107.405H540.511V108.994H532.887V114.032H540.445V115.61H532.887V121.93H540.445V123.518H531.277V107.405Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M553.736 123.518V107.405H554.086L564.799 119.739V107.405H566.387V123.518H566.026L555.401 111.338V123.518H553.736Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M578.165 108.972V107.405H589V108.972H584.41V123.518H582.767V108.972H578.165Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.643d3f0f1bb31286dabc0a3e312d5eb4.svg";
export { ForwardRef as ReactComponent };